import { forwardRef, type Ref, type SVGProps } from "react";
const IconRadioButtonFilledSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M16 21a5 5 0 1 0 0-10 5 5 0 0 0 0 10" /><path fill="currentColor" fillRule="evenodd" d="M16 4C9.373 4 4 9.373 4 16s5.373 12 12 12 12-5.373 12-12S22.627 4 16 4M8 16a8 8 0 1 1 16 0 8 8 0 0 1-16 0" clipRule="evenodd" /></svg>;
const ForwardRef = forwardRef(IconRadioButtonFilledSVG);
ForwardRef.displayName = "IconRadioButtonFilled";
export { ForwardRef as IconRadioButtonFilled };